import html2canvas from 'html2canvas-pro';


export const takeScreenShot = (ElementId, exportFileName) => {
    const element = document.getElementById(ElementId);
    if (!element) {
        console.error("Element not found");
        return;
    }

    html2canvas(element)
        .then((canvas) => {
            canvas.style.display = 'none'
            document.body.appendChild(canvas)
            return canvas
        }).then(canvas => {
            const image = canvas.toDataURL('image/png')
            const a = document.createElement('a')
            a.setAttribute('download', `${exportFileName}.png`)
            a.setAttribute('href', image)
            a.click()
            canvas.remove()
        }).catch((error) => {
            console.error(error);
        });
}
